module.exports = __webpack_public_path__ + "fonts/Lato-HeavyItalic.4c67ae6f.eot";